var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var TorsoEvents = require('backbone-torso/modules/Events');
var demographicsEmploymentTemplate = require('./demographicsEmploymentTemplate.hbs');
var handlebars = require('hbsfy/runtime');
var DemographicsValidationBehavior = require('./../behaviors/DemographicsValidationBehavior');

/**
 * View for displaying the employment information for patient demographics
 *
 * @class DemographicsEmploymentView
 * @constructor
 */
module.exports = TorsoView.extend({
  tagName: 'section',
  className: 'content-block',
  template: demographicsEmploymentTemplate,

  behaviors: {
    validationBehavior: {
      behavior: DemographicsValidationBehavior
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} configuration for this view
   *   @param options.dataModel {Object} contains all the data pertaining to employment
   *   @param options.highLevelConfig {Object} the high level configuration for the whole view
   *   @param options.config {Object} contains the configuration for employment information
   *   @param options.isInPreReg {boolean} whether it's in pre-reg or not
   *   @param options.editUrl {String} the url for corresponding edit view out of pre-reg
   *   @param options.preRegEditUrl {String} the url for corresponding edit view in pre-reg
   */
  initialize: function(options) {
    this._dataProperty = options.dataProperty || this._dataProperty;
    this._demographicsModel = options.dataModel || this._demographicsModel;
    this._config = options.config || this._config;
    this._isInPreReg = options.isInPreReg || this._isInPreReg;
    this._editUrl = options.editUrl || this._editUrl;
    this._preRegEditUrl = options.preRegEditUrl || this._preRegEditUrl;


    this.generateContext();
    this.listenTo(this._demographicsModel, 'change:' + this._dataProperty, this.generateContext);
    this.listenTo(this.viewState, 'change:context', this.render);
  },

  /**
   * Calculate the context based on data and configuration and set it on the view state
   * @method generateContext
   */
  generateContext: function() {
    var context = TorsoView.prototype.prepare.apply(this);

    context.model = _.clone(this._demographicsModel.get(this._dataProperty));
    context.editUrl = this._isInPreReg ? this._preRegEditUrl : this._editUrl;
    context.config = {};

    context.config.employerName = this._getConfig(this._config.employerName, context.model.employerName);
    context.config.employerPhone = this._getPhoneConfig(this._config.employerPhone, context.model.employerPhone);
    context.config.retired = this._getConfig(this._config.retired, context.model.retired);
    context.config.status = this._getConfig(this._config.status, context.model.status);

    var hasData = false;
    _.each(context.config, function(config) {
      if (config.hasData) {
        hasData = true;
      }
    });

    context.config.noData = !this.hasRequiredFields() & !hasData;

    this.set('context', context);
    TorsoEvents.trigger('demographics:validate');
  },

  /**
   * @method _getConfig
   * @private
   * @param config the configuration for each fields
   * @param contextModel the model in context for each fields
   * @return the configuration in context for each fields
   */
  _getConfig: function(config, contextModel) {
    var contextConfig = {};
    contextConfig.disabled = config.fieldPermissions === 'DISABLED';
    contextConfig.hasData = !_.isEmpty(contextModel);
    contextConfig.required = config.validationConfiguration && config.validationConfiguration.required;
    contextConfig.missing = contextConfig.required && !contextConfig.hasData;
    return contextConfig;
  },

  /**
   * @method _getPhoneConfig
   * @private
   * @param config the configuration for employerPhone field
   * @param contextModel the model in context for employerPhone field
   * @return the configuration in context for employerPhone field
   */
  _getPhoneConfig: function(config, contextModel) {
    contextModel = contextModel || {};
    var contextConfig = this._getConfig(config, contextModel);
    contextConfig.hasData = !!handlebars.helpers.formatPhoneNumber(contextModel);
    contextConfig.invalid = contextConfig.required && !(contextModel.areaCode && contextModel.exchange && contextModel.digits);
    contextConfig.missing = contextConfig.required && !contextConfig.hasData;
    return contextConfig;
  }
});
